interface PlaylistAddCheckProps {
  size?: number;
  fill?: string;
}

const PlaylistAddCheck = ({ size = 24, fill = '#4F4C4D' }: PlaylistAddCheckProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
    >
      <path
        fill={fill}
        d="M14 10H2v2h12v-2zm0-4H2v2h12V6zM2 16h8v-2H2v2zm19.5-4.5L23 13l-6.99 7-4.51-4.5L13 14l3.01 3 5.49-5.5z"
      ></path>
    </svg>
  );
};

export default PlaylistAddCheck;
